import { withChildren } from '@builder.io/react';
import { createBuilderModule } from '../../builder';
import { Visibility } from './Visibility';

export default createBuilderModule(withChildren(Visibility), {
  name: 'Visibility',
  image: 'https://cdn.zappy.app/7f0a7450fe514e4284bf33f3a819acb0.svg',
  inputs: [
    {
      name: 'hideOnMobile',
      type: 'boolean',
      defaultValue: false,
    },
    {
      name: 'hideOnTablet',
      type: 'boolean',
      defaultValue: false,
    },
    {
      name: 'hideOnDesktop',
      type: 'boolean',
      defaultValue: false,
    },
  ],
});
